import { useEffect, useState } from 'react'

import {
  getStoredPrincipal,
  onApiTokenChange,
  type StoredPrincipal
} from '../utils/apiAuth'

export const useStoredPrincipal = (): StoredPrincipal | null => {
  const [principal, setPrincipal] = useState<StoredPrincipal | null>(() => getStoredPrincipal())

  useEffect(() => {
    return onApiTokenChange(() => {
      setPrincipal(getStoredPrincipal())
    })
  }, [])

  return principal
}
